import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  detail: {},
};

export const counterSlice = createSlice({
  name: "contests",
  initialState,
  reducers: {
    setDetail: (state, action) => {
      state.detail = action.payload;
    },
    setList: (state, action) => {
      state.list = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setList, setDetail } = counterSlice.actions;

export default counterSlice.reducer;
